import { FOOTER_1_CONSTANTS } from "./footer_1";

/**
 * Footer 1034 — BDU Footer
 * Background-image panel, centred (mobile) / left-aligned (desktop) link columns each
 * with a white rule under the heading, a divider, then the disclaimer and copyright.
 *
 * The category and link field configs are identical to Footer 1 (same `footer_category`
 * / `footer_item` tables and the same Form_3 flow), so they are reused rather than
 * duplicated.
 *
 * The background art is a hardcoded asset in the reference, so it stays hardcoded in
 * the widget (`public/images/bdu_footer_background.png`) and is not a CMS field.
 */

export const FOOTER_1034_CONSTANTS = {
  DEFAULT_ROW: FOOTER_1_CONSTANTS.DEFAULT_ROW,
  CATEGORY_FIELDS_CONFIG: FOOTER_1_CONSTANTS.CATEGORY_FIELDS_CONFIG,
  FOOTER_TABLE_FIELDS_CONFIG: FOOTER_1_CONSTANTS.FOOTER_TABLE_FIELDS_CONFIG,

  FOOTER_FIELDS_CONFIG: [
    {
      fieldName: "enable_footer_content",
      label: "Show link columns",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
    {
      fieldName: "text_color",
      label: "Column heading + link colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "gradient_start_color",
      label: "Divider under the columns",
      value: "#5B789F",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#5B789F",
    },
    {
      fieldName: "title",
      label: "Disclaimer line",
      value: "Disclaimer: bduedu.in is owned by bdu.ac.in",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "Disclaimer: bduedu.in is owned by bdu.ac.in",
    },
    {
      fieldName: "title_text_color",
      label: "Disclaimer colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "enable_copyright",
      label: "Show copyright line",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
    {
      fieldName: "copyright_text",
      label: "Copyright line (a 'privacy policy' link is appended)",
      value:
        "Copyright 2026 of Bharathidasan University | All Rights Reserved",
      valueType: "string",
      filedType: "INPUT",
      defaultValue:
        "Copyright 2026 of Bharathidasan University | All Rights Reserved",
    },
    {
      fieldName: "copyright_text_color",
      label: "Copyright colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
